const frTranslation = {
  common: {
    close: 'Fermer',
    welcome: 'Bienvenue',
    login: 'Connexion',
    logout: 'Déconnexion',
    send: 'Envoyer',
    stop: 'Arrêter',
    retry: 'Réessayer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    typeToFilter: 'Tapez pour filtrer…',
    save: 'Enregistrer',
    language: 'Langue',
    newChat: 'Nouvelle conversation',
    startingNewChat: "Démarrage d'une nouvelle conversation...",
    searchMessage: 'Réflexion et analyse des informations pertinentes...',
    searchMessageTiming: 'Recherche dans les instructions de travail et les éléments de connaissance...',
    tryAgain: 'Réessayer',
    back: 'Retour',
    enabled: 'Activé',
    disabled: 'Désactivé',
    goBack: 'Revenir',
    attachDocument: 'Joindre un document',
    aiDisclaimer:
      "Les réponses sont générées par l'IA. Vérifiez toujours les informations importantes via des sources officielles.",
    copyAnswer: 'Copier la réponse',
    copyMessage: 'Copier le message',
    copied: 'Copié !',
    copyToClipboard: 'Copier dans le presse-papiers',
    expand: 'Développer',
    minimize: 'Minimiser',
    showMore: 'Voir plus',
    noInternalKnowledge: 'Aucune connaissance interne trouvée',
    noAdditionalResponse: 'Pas de réponse supplémentaire',
    swapMessage:
      "Nous avons trouvé une réponse spécifique à l'entreprise. La réponse générale est toujours disponible ci-dessous.",
    toggleShowGeneral: 'Afficher la réponse générale (ChatGPT)',
    toggleHideGeneral: 'Masquer la réponse générale',
    progressExternal: 'Recherche avec ChatGPT…',
    progressInternal: 'Recherche dans la base interne…',
    internalError: 'Connaissances internes actuellement indisponibles.',
    promoteSecondary: 'Utiliser comme réponse principale',
    compareAnswers: 'Comparer les réponses côte à côte',
    switchBack: 'Revenir',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Directives internes',
  },
  // Retrieval-step labels, keyed by graph tool prefix. A per-source key
  // (`tools.graph_search_<key>.done`) overrides these when one is defined.
  tools: {
    graph_search: {
      active: 'Recherche dans le knowledge graph…',
      done: 'Knowledge graph consulté',
    },
    ask_clarification: {
      active: "Préparation d'une question de clarification…",
      done: 'Question de clarification posée',
    },
    unknown: {
      active: '{{name}} en cours…',
      done: '{{name}} terminé',
    },
    statusDone: 'Terminé',
    statusRunning: 'En cours…',
  },
  clarification: {
    escapeHatchLabel: 'Saisir ma propre réponse',
    skip: 'Passer',
    submit: 'Envoyer',
    nextQuestion: 'Question suivante',
    previousQuestion: 'Question précédente',
    selectAllThatApply: '(Sélectionnez toutes les réponses applicables)',
    stepCounter: '{{current}} sur {{total}}',
    selectedCount: '{{count}} sélectionné(s)',
    selectOption: 'Sélectionner {{label}}',
    deselectOption: 'Désélectionner {{label}}',
    shortcutHint: '↑↓ naviguer · Entrée sélectionner · Maj+Entrée envoyer · Échap passer',
  },
  knowledge_source: {
    badge_ai: 'IA',
    badge_internal: 'Données de l\'entreprise',
    badge_internet: 'Internet',
  },
  errors: {
    assistantResponseContentViolation:
      "La réponse de l'assistant enfreint notre politique de contenu. Veuillez réessayer ou reformuler votre question.",
    userInputContentViolation:
      'Votre demande contient du contenu qui enfreint notre politique. Veuillez reformuler votre question.',
    llmProviderUserInputBlocked:
      "Votre message a été bloqué par le filtre de contenu du fournisseur d'IA. Veuillez reformuler votre question.",
    llmProviderBotResponseBlocked:
      "La réponse de l'IA a été bloquée par le filtre du fournisseur. Veuillez réessayer ou reformuler votre question.",
    llmProviderApiError: 'Nous rencontrons des problèmes avec notre service IA. Veuillez réessayer plus tard.',
    modelRateLimited:
      "Le modèle d'IA est actuellement surchargé. Veuillez réessayer — s'il le reste, un autre modèle répondra.",
    modelTimeout: "Le modèle d'IA a mis trop de temps à répondre. Veuillez réessayer.",
    modelUnavailable:
      "Le modèle d'IA est actuellement indisponible. Veuillez réessayer — un autre modèle répondra.",
    serverError:
      "Une erreur serveur imprévue s'est produite. Veuillez réessayer ou contacter le support si le problème persiste.",
    agentNotFound: "L'assistant que vous recherchez n'existe pas ou n'est plus disponible.",
    conversationNotFound: "La conversation que vous recherchez n'existe pas ou n'est plus disponible.",
    noAccessScopes:
      "Vous n'avez actuellement accès à aucune source de connaissances. Pour demander l'accès, veuillez créer un ticket de support ou contacter votre administrateur informatique.",
    noAccessScopesWithEmail:
      "Vous n'avez actuellement accès à aucune source de connaissances. Pour demander l'accès, veuillez créer un ticket de support ou contacter le support informatique à l'adresse {{email}}.",
    startViolatedPoliciesList: 'Les politiques suivantes ont été violées',
    questionTooLong: {
      title: 'Votre question est trop longue',
      description: 'La longueur maximale est de 30 000 caractères.',
    },
    excelNotSupportedYet: {
      title: 'Le support Excel et CSV arrive bientôt !',
      description:
        "Nous travaillons sur la prise en charge des fichiers Excel et CSV qui sera bientôt disponible. Veuillez utiliser pour l'instant des fichiers PDF ou Word.",
    },
    internetSearchNotWaiting: 'Cette recherche a déjà reçu une réponse, par exemple dans un autre onglet. Actualisez la page pour voir le résultat.',
  },
  auth: {
    welcomeTester: 'Bienvenue collègue',
    welcomeMessage: 'Bienvenue sur {{assistantName}} !',
    loginWithMicrosoft: 'Se connecter avec Microsoft',
    loginInstructions: 'Connectez-vous avec votre compte Microsoft pour commencer.',
    welcomeCompany: 'Bienvenue chez {{companyName}} !',
    loginWithPassword: 'Se connecter avec identifiant et mot de passe',
    hidePasswordForm: 'Masquer',
    login: 'Connexion',
  },
  chat: {
    placeholder: 'Posez votre question ici',
    thinking: 'Réflexion...',
    anonymousUser: 'Anonyme',
    howToAskGoodQuestion: 'Comment poser une bonne question ?',
    askQuestion: 'Posez votre question',
    exampleQuestions: 'Exemples de questions',
    tryAsking: 'Essayez de demander :',
    assistant: '{{assistantName}}, votre assistant digital',
    welcomeMessage:
      'Bonjour {{name}} ! Je suis {{assistantName}}, votre assistant digital. Je peux vous aider pour les questions sur les instructions de travail et les éléments de connaissance. Que voulez-vous savoir ?',
    loading: 'Chargement de la conversation...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    serverError:
      "Une erreur serveur imprévue s'est produite. Veuillez réessayer ou contacter le support si le problème persiste.",
    disclaimerText:
      "Réponses générées par l'IA. Aucun droit ne peut être tiré de ces réponses.",
    dropFilesHere: 'Déposez les fichiers ici pour les ajouter au chat',
    addMenu: 'Ajouter',
    addFiles: 'Ajouter un fichier',
    knowledgeSourceOff: '{{name}} désactivé',
    filteredTo: 'Filtré sur',
    talkingTo: 'Vous parlez avec {{name}}',
    leaveAgent: 'Quitter {{name}}',
    askAgain: 'Demander à un autre assistant',
    askAgent: 'Demander à {{name}}',
    filters: 'Filtres',
    filtersInfo: 'Limite la conversation à des filtres spécifiques.',
    unsupportedFileType: 'Type de fichier non pris en charge',
    uploadingFile: 'Téléversement du fichier…',
    uploadLimit: "Jusqu'à {{max}} fichiers, 10 Mo chacun",
    fileTooLarge: 'Le fichier doit faire moins de 10 Mo',
    fileTypeNotAllowed: 'Seuls les fichiers PDF, Word, Excel, PowerPoint (PPTX), CSV et TXT sont autorisés',
    fileTypeNotAllowedWithImages:
      'Seuls les fichiers PDF, Word, Excel, PowerPoint (PPTX), CSV, TXT et images (PNG, JPEG, WEBP) sont autorisés',
    documentUploadFailed: 'Échec du téléversement du document',
    tooManyFiles: "Vous pouvez joindre jusqu'à {{max}} fichiers par message",
    attachmentsNotReady: 'Attendez que tous les fichiers soient téléversés, ou supprimez ceux qui ont échoué',
    retryAttachment: 'Téléverser à nouveau {{name}}',
    removeAttachment: 'Supprimer {{name}}',
  },
  answerStatus: {
    checking: 'Vérification des requêtes…',
    internet: 'Recherche sur Internet : {{query}}',
    knowledge: 'Recherche dans les données de l\'entreprise : {{query}}',
    document: 'Lecture de votre document…',
    files_one: 'Traitement du fichier : {{name}}',
    files_other: 'Traitement de {{count}} fichiers…',
    image: 'Analyse de l\'image…',
    imageNamed: 'Analyse de l\'image : {{name}}',
    slowFiles: 'Les gros fichiers contenant beaucoup d\'images peuvent prendre quelques minutes…',
  },
  internetSearch: {
    badgeLabel: 'Recherche sur Internet',
    queriesSent_one: '{{count}} requête envoyée',
    queriesSent_other: '{{count}} requêtes envoyées',
    badgeTooltip: 'Cet assistant peut effectuer des recherches sur Internet',
    approval: {
      queryTooLong: 'Limitez la requête à 500 caractères maximum.',
      title: 'Autoriser la recherche sur Internet ?',
      descriptionOne: 'Cette requête est envoyée sur Internet et contient peut-être des informations confidentielles (surlignées). Modifiez-la ou envoyez-la telle quelle.',
      descriptionMany: 'Ces requêtes sont envoyées sur Internet et contiennent peut-être des informations confidentielles (surlignées). Modifiez-les ou envoyez-les telles quelles.',
      descriptionUncheckedOne: 'Cette requête est envoyée sur Internet. Nous n’avons pas pu la vérifier automatiquement : relisez-la avant de l’envoyer.',
      descriptionUncheckedMany: 'Ces requêtes sont envoyées sur Internet. Nous n’avons pas pu les vérifier automatiquement : relisez-les avant de les envoyer.',
      descriptionCleanOne: 'Cette requête est envoyée sur Internet. Relisez-la : modifiez-la ou envoyez-la telle quelle.',
      descriptionCleanMany: 'Ces requêtes sont envoyées sur Internet. Relisez-les : modifiez-les ou envoyez-les telles quelles.',
      queryLabel: 'Requête de recherche',
      dropQuery: 'Ne pas rechercher',
      dropped: 'Ne sera pas recherchée',
      undrop: 'Rechercher quand même',
      sendSearch: 'Lancer la recherche',
      useInternal: 'Utiliser les données internes',
      continueWithoutInternet: 'Continuer sans Internet',
      internalStatus: 'Recherche sur Internet ignorée · Utilisation des données internes',
      noInternetStatus: 'Recherche sur Internet ignorée · Réponse sans Internet',
      categories: {
        customer: 'nom du client',
        person: 'personne',
        vessel: 'navire',
        project: 'projet',
        internal_code: 'code interne',
        contact: 'coordonnées',
        financial: 'financier',
        credential: 'identifiants de connexion',
        identifier: "numéro d'identification",
        special_category: 'données personnelles sensibles',
        confidential: 'confidentiel',
        other: 'peut-être confidentiel',
      },
    },
  },
  agentChat: {
    placeholder: "Saisissez votre question pour l'agent...",
    welcomeMessage: "Bonjour, je suis votre agent IA. Comment puis-je vous aider aujourd'hui ?",
    privilegedWelcomeMessage: 'Bonjour {{userName}} ! {{description}}',
    startPrompt: 'Posez une question pour commencer',
  },
  profile: {
    settings: 'Paramètres',
    selectLanguage: 'Sélectionnez votre langue',
    appearance: 'Apparence',
    darkMode: 'Mode sombre',
    languageChanged: 'Langue modifiée',
    noEmailAvailable: 'Aucun e-mail disponible',
    general: 'Général',
    models: 'Modèles',
    noModelsAvailable: 'Aucun modèle disponible',
    modelSettings: 'Paramètres du modèle',
    savingSettings: 'Enregistrement...',
    settingsUpdateFailed: "Échec de l'enregistrement des paramètres du modèle. Veuillez réessayer.",
  },
  sidebar: {
    conversations: 'Historique',
    assistants: 'Assistants',
    userGuide: "Guide d'utilisation",
    chatHistory: 'Historique des conversations',
    today: "Aujourd'hui",
    thisWeek: 'Cette semaine',
    lastWeek: 'La semaine dernière',
    earlier: 'Plus tôt',
    conversation: 'Conversation',
    noAssistantsAvailable: 'Aucun assistant disponible',
    noContent: 'Pas de contenu',
    noPreviousConversations: 'Aucun historique précédent trouvé',
    searchConversations: "Rechercher dans l'historique...",
    noSearchResults: 'Aucun historique correspondant à votre recherche',
    favorites: 'Favoris',
    noFavorites: 'Aucun favori',
    addFavoritesHint: 'Allez à la bibliothèque pour ajouter des assistants à vos favoris.',
    loadingPrivilegedAgents: 'Chargement des assistants...',
    rename: 'Renommer',
    conversationActions: 'Actions de conversation',
    renameConversationError: 'Échec du renommage de la conversation',
    delete: 'Supprimer',
    deleteConversation: 'Supprimer la conversation',
    deleteConversationConfirm: 'Êtes-vous sûr de vouloir supprimer la conversation : {{title}} ?',
    deleteConversationError: 'Échec de la suppression de la conversation',
  },
  feedback: {
    likeAnswer: "J'aime la réponse",
    dislikeAnswer: "Je n'aime pas la réponse",
    feedbackSent: 'Votre avis a été envoyé ! ✅',
    provideFeedback: 'Donner un retour sur la question',
    enterFeedback: 'Saisissez votre retour ici',
    send: 'Envoyer',
    assistantFallback: "assistant IA",
    downvoteDisclaimer:
      "Lorsque vous appuyez sur Envoyer, vos deux derniers messages seront partagés de manière anonyme à des fins d'analyse pour aider à améliorer {{assistant}}.",
    reasons: {
      incorrect: 'La réponse est incorrecte',
      sourceIncorrect: 'La source est incorrecte',
      other: 'Autre...',
    },
  },
  // Generic information pop-out — client-agnostic.
  // Texts are feature-flag driven and use {{companyName}} for the company name.
  informationModal: {
    title: "À propos de l'assistant {{companyName}}",
    intro:
      "Bienvenue sur l'assistant {{companyName}}. Vous trouverez ci-dessous ce que l'assistant peut faire pour vous et comment en tirer le meilleur parti.",
    capabilitiesTitle: "Avec quoi l'assistant peut-il vous aider ?",
    activeVanillaChat:
      "L'assistant peut répondre aux questions comme celles que vous poseriez à ChatGPT.",
    activeVanillaInactiveWebSearch:
      "L'assistant possède de larges connaissances générales, mais ne connaît pas l'actualité comme les dernières nouvelles.",
    activeInternalSearch:
      "L'assistant peut répondre aux questions à partir d'une sélection spécifique de sources d'information internes.",
    activeInternetSearch:
      "L'assistant peut effectuer des recherches sur internet pour répondre aux questions d'actualité.",
    activeInternetSearchPrivacyWarning:
      "Remarque : les questions et réponses des recherches internet, comme l'utilisation classique d'internet, ne sont pas totalement privées. Ne partagez pas d'informations confidentielles de l'entreprise lorsque vous utilisez la recherche web.",
    activeDocumentUpload:
      "Vous pouvez téléverser des documents et en discuter avec l'assistant, par exemple pour les résumer ou en extraire des points d'action.",
    activeAgents:
      "Vous pouvez sélectionner des <1>assistants</1> spécifiques avec qui discuter. Chaque assistant a ses propres instructions et est donc plus efficace pour des tâches spécifiques.",
    activeModelSelection:
      "Dans le champ de saisie, vous choisissez quel modèle d'IA répond à votre question. Sur la <1>page des paramètres des modèles</1>, vous ajustez les paramètres de chaque modèle pour contrôler sa façon de répondre.",
    usageTipsTitle: "Comment tirer le meilleur parti de l'assistant",
    askClearQuestions:
      'Posez une question claire en phrases complètes. Des mots-clés isolés donnent souvent des réponses médiocres ; une phrase complète fournit à l\'assistant le contexte nécessaire pour bien vous aider.',
    conversationHistory:
      "Au sein d'une conversation, l'assistant retient ce que vous avez dit précédemment, afin que vous puissiez poser des questions de suivi. Il ne comprend cependant pas ce que vous voulez dire lorsque vous faites référence à des informations issues d'autres conversations.",
    startNewConversation:
      "Démarrez une nouvelle conversation (bouton en haut à gauche) lorsque vous changez de sujet, ainsi les réponses restent pertinentes.",
    bewareAssistantsNotAgents:
      "Remarque : ceci est un assistant IA, pas un agent IA. Il vous aide pour des tâches ponctuelles lorsque vous le demandez, par exemple résumer un e-mail, mais n'effectue pas d'actions de suivi de manière autonome, comme envoyer des e-mails.",
    feedback:
      "Utilisez les pouces sous une réponse pour donner votre avis. Cela aide à améliorer l'assistant.",
    dataVisibilityNoticeTitle: 'Avis de visibilité des données',
    bewareDoNotSharePersonalInformation: "Remarque : ne partagez pas d'informations personnelles.",
    supportTitle: 'Besoin d\'aide ?',
  },
  conversations: {
    noAssistantsMessage: "On dirait qu'aucune bibliothèque n'est configurée. Veuillez contacter le support.",
    searchPlaceholder: 'Rechercher des conversations',
    newChat: 'Nouvelle conversation',
    untitledConversation: 'Conversation sans titre',
    emptyStateTitle: 'Aucune conversation',
    emptyStateDescription: "Vous n'avez pas encore de conversations.",
    delete: 'Supprimer',
    share: 'Partager',
    rename: 'Renommer',
    copyLink: 'Copier le lien',
    copiedLink: 'Lien de conversation copié !',
    deleteWarning: 'Êtes-vous sûr ? Ce chat sera définitivement supprimé.',
    deleteFailed: 'Échec de la suppression du chat',
    deleteSuccess: 'Chat supprimé',
  },
  homePage: {
    title: 'Discuter avec {{assistantName}}',
    subtitle:
      "{{assistantName}} est un chatbot spécialisé dans les connaissances de votre entreprise.",
    newChat: 'Nouvelle conversation',
    search: 'Rechercher',
    feedback: 'Retour',
    seeExamples: 'Voir des exemples',
    featuredTopics: 'Sujets en vedette',
    startWithTopic: 'Commencer avec un sujet',
    appFeatures: "Fonctionnalités de l'application",
    libraryInformation: 'Informations de la bibliothèque',
  },
  search: {
    noResults: 'Aucun résultat trouvé',
    tryDifferentQuery: 'Essayez une autre requête ou recherchez un autre mot clé',
  },
  share: {
    inviteColleagues: 'Invitez vos collègues à essayer {{assistantName}}',
    and: 'et',
    shareConversations: 'Partagez vos conversations avec les autres',
    sharePublic: 'Partager avec un lien',
    shareTeams: 'Partager dans Teams',
    shareCopy: 'Copier',
    shared: 'Partagé',
  },
  profilePage: {
    personalInformation: 'Informations personnelles',
    fullName: 'Nom complet',
    email: 'E-mail',
    accountId: 'ID du compte',
    role: 'Rôle',
    language: 'Langue',
    memberSince: 'Membre depuis',
  },
  assistantLibrary: {
    title: "Bibliothèque d'assistants",
    subtitle: 'Choisissez un assistant pour commencer',
    searchPlaceholder: 'Rechercher des assistants...',
    category: 'Catégorie',
    allCategories: 'Toutes les catégories',
    sortBy: 'Trier par',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    name: 'Nom',
    description: 'Description',
    mostPopular: 'Les plus populaires',
    myFavorites: 'Mes favoris',
    results: 'Résultats',
    result: 'Résultat',
    noResultsFound: 'Aucun assistant trouvé',
    assistantCard: {
      created: 'Créé',
      updated: 'Mis à jour',
      cta: 'Commencer le chat',
    },
    filters: {
      reset: 'Réinitialiser',
      showFilters: 'Afficher les filtres',
      hideFilters: 'Masquer les filtres',
    },
  },
  libraryBanner: {
    title: "Bienvenue dans la bibliothèque d'assistants",
    description:
      "Vous trouverez ici des assistants spécialisés pour différents besoins, notamment la conformité RH, le support technique, la formation des utilisateurs, l'analyse de données et plus encore.",
    readyToChat: 'Prêt à discuter ?',
    browseAssistants: 'Parcourir les assistants',
  },
  assistant: {
    welcomeTitle: 'Bienvenue chez {{name}}',
    welcomeMessage:
      "Saisissez votre question ou sélectionnez l'une des questions exemples ci-dessous pour commencer.",
    conversations: 'Conversations',
    settings: 'Paramètres',
    description: 'Description',
    noDescription: 'Aucune description disponible',
    exampleQuestions: 'Questions exemples',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    createdBy: 'Créé par',
    timezone: 'Fuseau horaire',
    language: 'Langue',
    public: 'Public',
    private: 'Privé',
    knowledgeSource: 'Source de connaissance',
    noKnowledgeSource: 'Aucune source de connaissance fournie',
    chat: 'Chat',
    prompts: 'Prompts',
    files: 'Fichiers',
    instructions: 'Instructions',
    loading: "Chargement de l'assistant...",
    loadFailed: "Impossible de charger l'assistant",
    retry: 'Réessayer',
    startChat: 'Commencer le chat',
    startNewChat: 'Commencer un nouveau chat',
    inputPlaceholder: 'Saisissez votre message...',
    uploadFile: 'Téléverser un fichier',
    fileUploaded: 'Fichier téléversé',
    fileRemoved: 'Fichier supprimé',
    fileUploadError: 'Erreur lors du téléversement du fichier',
    fileRemoveError: 'Erreur lors de la suppression du fichier',
    fileTooLarge: 'Fichier trop volumineux',
    fileTooLargeDescription: 'La taille maximale du fichier est de 10 Mo',
    fileTypeNotAllowed: 'Type de fichier non autorisé',
    fileTypeNotAllowedDescription: 'Types de fichiers autorisés : PDF, DOCX, TXT',
    send: 'Envoyer',
    sending: 'Envoi...',
    messageSent: 'Message envoyé',
    messageFailed: "Échec de l'envoi du message",
    newMessage: 'Nouveau message',
    clearChat: 'Effacer le chat',
    confirmClearChat: 'Êtes-vous sûr de vouloir effacer le chat ? Cette action ne peut pas être annulée.',
    chatCleared: 'Chat effacé',
    chatClearFailed: "Échec de l'effacement du chat",
    copyConversation: 'Copier la conversation',
    conversationCopied: 'Conversation copiée',
    copyFailed: 'Échec de la copie',
    feedback: 'Retour',
    submitFeedback: 'Envoyer le retour',
    feedbackSent: 'Retour envoyé',
    feedbackFailed: "Échec de l'envoi du retour",
    feedbackPlaceholder: "Comment s'est passée votre expérience ?",
    ratingRequired: 'Veuillez sélectionner une note',
    optional: 'Facultatif',
    required: 'Obligatoire',
  },
  assistantSettings: {
    title: "Paramètres de l'assistant",
    description: 'Ajustez la configuration de votre assistant',
    tabs: {
      general: 'Général',
      permissions: 'Autorisations',
      knowledge: 'Connaissance',
      behavior: 'Comportement',
    },
    save: 'Enregistrer les paramètres',
    saved: 'Paramètres enregistrés',
    saveError: "Erreur lors de l'enregistrement des paramètres",
  },
  assistantGeneral: {
    title: 'Paramètres généraux',
    name: 'Nom',
    description: 'Description',
    timezone: 'Fuseau horaire',
    language: 'Langue',
    visibility: 'Visibilité',
    public: 'Public',
    private: 'Privé',
    save: 'Enregistrer',
    saved: 'Enregistré',
    saveError: "Erreur lors de l'enregistrement",
  },
  assistantPermissions: {
    title: 'Autorisations',
    addUser: 'Ajouter un utilisateur',
    addGroup: 'Ajouter un groupe',
    searchUsers: 'Rechercher des utilisateurs',
    searchGroups: 'Rechercher des groupes',
    invite: 'Inviter',
    invited: 'Invité',
    inviteError: "Erreur lors de l'invitation",
    remove: 'Supprimer',
    removed: 'Supprimé',
    removeError: 'Erreur lors de la suppression',
    access: 'Accès',
    accessLevels: {
      owner: 'Propriétaire',
      editor: 'Éditeur',
      viewer: 'Lecteur',
    },
  },
  assistantKnowledge: {
    title: 'Source de connaissance',
    addSource: 'Ajouter une source',
    searchSources: 'Rechercher des sources',
    upload: 'Téléverser',
    uploaded: 'Téléversé',
    uploadError: 'Erreur de téléversement',
    remove: 'Supprimer',
    removed: 'Supprimé',
    removeError: 'Erreur lors de la suppression',
    sourceType: 'Type de source',
    sourceTypes: {
      document: 'Document',
      url: 'URL',
      database: 'Base de données',
    },
  },
  assistantBehavior: {
    title: 'Comportement',
    instructions: 'Instructions',
    addInstruction: 'Ajouter une instruction',
    model: 'Modèle',
    temperature: 'Température',
    maxTokens: 'Nombre max de tokens',
    topP: 'Top P',
    frequencyPenalty: 'Pénalité de fréquence',
    presencePenalty: 'Pénalité de présence',
    reset: 'Réinitialiser',
    resetConfirm: 'Voulez-vous vraiment réinitialiser ce comportement aux valeurs par défaut ?',
    resetSuccess: 'Comportement réinitialisé',
    resetFailed: 'Échec de la réinitialisation',
  },
  promptTemplates: {
    title: 'Modèles de prompt',
    subtitle: 'Créer et gérer des prompts réutilisables',
    create: 'Créer un modèle',
    edit: 'Modifier le modèle',
    delete: 'Supprimer le modèle',
    name: 'Nom',
    description: 'Description',
    content: 'Contenu',
    created: 'Modèle créé',
    updated: 'Modèle mis à jour',
    deleted: 'Modèle supprimé',
    creationError: 'Erreur lors de la création du modèle',
    updateError: 'Erreur lors de la mise à jour du modèle',
    deletionError: 'Erreur lors de la suppression du modèle',
    deleteConfirmTitle: 'Supprimer le modèle',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
    deleteWarning: 'Cette action ne peut pas être annulée.',
  },
  promptForm: {
    name: 'Nom',
    namePlaceholder: 'Entrez le nom du modèle',
    nameHelp: 'Choisissez un nom descriptif pour votre modèle',
    description: 'Description',
    descriptionPlaceholder: 'Entrez la description du modèle',
    descriptionHelp: 'Bref aperçu du but du modèle',
    content: 'Contenu',
    contentPlaceholder: 'Entrez le contenu du prompt',
    contentHelp: 'Utilisez des variables comme {{name}} et {{context}}',
    save: 'Enregistrer le modèle',
    saving: 'Enregistrement...',
    saved: 'Modèle enregistré',
    saveError: "Erreur lors de l'enregistrement du modèle",
  },
  agentBuilder: {
    back: 'Retour',
    next: 'Suivant',
    saveAsDraft: 'Enregistrer comme brouillon',
    saveAndFinish: 'Enregistrer et terminer',
    launchAssistant: "Lancer l'assistant",
    previous: 'Précédent',
    continue: 'Continuer',
    cancel: 'Annuler',
  },
  createAgent: {
    title: 'Créer un assistant',
    subtitle: 'Configurez votre nouvel assistant IA',
    name: 'Nom',
    description: 'Description',
    language: 'Langue',
    timezone: 'Fuseau horaire',
    visibility: 'Visibilité',
    public: 'Public',
    private: 'Privé',
    next: 'Suivant',
    back: 'Retour',
    create: 'Créer un assistant',
    creating: 'Création...',
    created: 'Assistant créé',
    createError: "Erreur lors de la création de l'assistant",
    required: 'Ce champ est obligatoire',
    tools: 'Outils',
    toolsFileSearch: 'Recherche de fichiers',
    toolsImageInspection: "Inspection d'images",
    toolsKnowledgeSearch: 'Rechercher dans toutes les sources de connaissances',
    toolsGraphSearch: 'Rechercher dans le graphe de connaissances',
    toolsClarification: 'Poser des questions de clarification',
    toolsKnowledgeSource: 'Rechercher dans {{name}}',
    toolsColumnName: 'Outil',
    toolsColumnEnabled: 'Activé',
    toolsColumnTraced: 'Tracé',
    toolsTopK: 'Documents par recherche',
    toolsTopKHelp: 'Nombre de documents renvoyés par une recherche dans la base de connaissances. Laissez vide pour la valeur par défaut (5). Une valeur plus élevée couvre davantage, une valeur plus basse garde la réponse ciblée.',
    toolsTracedHelp: "Lorsque le mode de traçage de l'assistant est 'Lors de l'utilisation d'outils', l'utilisation de cet outil enregistre la conversation de manière anonyme à des fins d'analyse.",
    toolsInternetSearch: 'Recherche Internet',
    flags: 'Signalements',
    flagsHelp: "Choisissez les signalements que cet assistant peut afficher. Par défaut, tous s'appliquent — désactivez ceux qui ne concernent pas son sujet.",
    flagsColumnName: 'Signalement',
    flagsColumnSeverity: 'Gravité',
    flagsColumnEnabled: "S'applique",
    flagsSeverityInfo: 'Info',
    flagsSeverityWarning: 'Avertissement',
    flagsSeverityCritical: 'Critique',
    tracing: 'Traçage',
    tracingHelp: "Contrôle si et comment le comportement interne de cet agent est journalisé à des fins de diagnostic. Remplace les paramètres basés sur les outils",
    tracingAlways: 'Activé',
    tracingNever: 'Désactivé',
    tracingToolBased: 'Basé sur les outils',
    visibilityHelp: 'Contrôlez qui peut voir cet assistant. Les assistants privés ne sont visibles que par vous.',
    visibilityPublic: 'Rendre visible aux entités clientes sélectionnées',
    visibilityEntities: 'Entités clientes',
    visibilityEntitiesPlaceholder: 'Sélectionner des entités clientes',
    visibilityEntitiesHelp: "Les utilisateurs associés à l'une de ces entités peuvent voir cet assistant.",
    routing: 'Chat principal',
    routingHelp: 'Le chat principal transmet à cet assistant les questions qui lui correspondent. Le routeur lit la description de routage et les exemples de questions.',
    routingDescription: 'Description de routage',
    routingDescriptionPlaceholder: 'À utiliser pour : …\nNe pas utiliser pour : …\nExemples : …',
    routingDescriptionHelp: 'Indiquez à quoi sert cet assistant et, tout aussi important, à quoi il ne sert pas, surtout là où il touche à d’autres assistants. Utilisez les mots que les gens tapent vraiment, dans leur propre langue. {{count}}/{{max}} caractères.',
    routingDescriptionTooLong: '{{max}} caractères au maximum.',
    routingAvailable: 'Disponible dans le chat principal',
    routingNotReady: 'Nécessite une description de routage et au moins {{min}} exemples de questions.',
    routingUseClientContext: "Utiliser le contexte de l'entreprise",
    routingUseClientContextHelp: "Place le contexte de l'entreprise (sites, produits, culture) avant les propres instructions de cet assistant. Ses propres instructions priment.",
    unsavedChanges: 'Modifications non enregistrées',
    unsavedChangesMessage: "Vous avez effectué des modifications qui n'ont pas encore été enregistrées. Voulez-vous vraiment revenir en arrière ?",
  },
  agentAppearance: {
    title: 'Apparence',
    subtitle: "Personnalisez l'apparence de votre assistant",
    icon: 'Icône',
    color: 'Couleur',
    iconHelp: 'Choisissez une icône adaptée à votre marque',
    colorHelp: "Choisissez une couleur pour l'interface de l'assistant",
  },
  agentBehavior: {
    title: 'Comportement',
    subtitle: 'Contrôlez la façon dont votre assistant répond',
    systemPrompt: 'Prompt système',
    systemPromptHelp: 'Guidez le ton et la personnalité de votre assistant',
    guardrails: 'Garde-fous',
    guardrailsHelp: 'Définissez ce que votre assistant ne doit pas faire',
    temperature: 'Température',
    maxTokens: 'Nombre max de tokens',
    topP: 'Top P',
    frequencyPenalty: 'Pénalité de fréquence',
    presencePenalty: 'Pénalité de présence',
  },
  agentKnowledge: {
    title: 'Connaissance',
    subtitle: 'Connectez des sources de connaissance à votre assistant',
    uploadFiles: 'Téléverser des fichiers',
    addLinks: 'Ajouter des liens',
    addText: 'Ajouter du texte',
    upload: 'Téléverser',
    uploading: 'Téléversement...',
    uploaded: 'Téléversé',
    uploadError: 'Erreur de téléversement',
    remove: 'Supprimer',
    removed: 'Supprimé',
    removeError: 'Erreur lors de la suppression',
    maxFiles: "Jusqu'à 10 fichiers",
    maxSize: "Jusqu'à 10 Mo par fichier",
    supportedFormats: 'PDF, DOCX, TXT',
  },
  agentPreview: {
    title: 'Aperçu',
    subtitle: 'Testez votre assistant avant de le lancer',
    welcomeMessage: 'Bienvenue ! Je suis votre nouvel assistant. Comment puis-je aider ?',
    inputPlaceholder: 'Saisissez un message...',
    send: 'Envoyer',
  },
  agentReview: {
    title: 'Vérifier et lancer',
    subtitle: 'Passez en revue vos paramètres avant de lancer votre assistant',
    launch: "Lancer l'assistant",
    launching: 'Lancement...',
    launched: "Lanc'é",
    launchError: "Erreur lors du lancement de l'assistant",
  },
  agentValidation: {
    nameRequired: 'Le nom est obligatoire',
    descriptionRequired: 'La description est obligatoire',
    languageRequired: 'La langue est obligatoire',
    timezoneRequired: 'Le fuseau horaire est obligatoire',
  },
  assistantFilters: {
    title: 'Filtres',
    clearAll: 'Effacer tout',
    apply: 'Appliquer',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    visibility: 'Visibilité',
    all: 'Tous',
    public: 'Public',
    private: 'Privé',
  },
  timezones: {
    search: 'Rechercher des fuseaux horaires...',
    noResults: 'Aucun fuseau horaire trouvé',
  },
  languages: {
    search: 'Rechercher des langues...',
    noResults: 'Aucune langue trouvée',
  },
  alerts: {
    successTitle: 'Succès',
    errorTitle: 'Erreur',
    warningTitle: 'Avertissement',
    infoTitle: 'Info',
  },
  validation: {
    required: 'Ce champ est obligatoire',
    invalidEmail: 'Adresse e-mail invalide',
    minLength: 'Longueur minimale {{count}} caractères',
    maxLength: 'Longueur maximale {{count}} caractères',
  },
  date: {
    today: "Aujourd'hui",
    yesterday: 'Hier',
    daysAgo: 'il y a {{count}} jours',
  },
  attachments: {
    dropFiles: 'Déposez des fichiers ici pour téléverser',
    browse: 'Parcourir',
    uploading: 'Téléversement...',
    upload: 'Téléverser',
    uploaded: 'Téléversé',
    uploadError: 'Erreur de téléversement',
    remove: 'Supprimer',
    removed: 'Supprimé',
    removeError: 'Erreur lors de la suppression',
  },
  prompts: {
    title: 'Prompts',
    subtitle: 'Gérez les modèles de prompts et les préréglages',
    create: 'Créer un prompt',
    edit: 'Modifier le prompt',
    delete: 'Supprimer le prompt',
    name: 'Nom',
    description: 'Description',
    content: 'Contenu',
    created: 'Prompt créé',
    updated: 'Prompt mis à jour',
    deleted: 'Prompt supprimé',
    creationError: 'Erreur lors de la création du prompt',
    updateError: 'Erreur lors de la mise à jour du prompt',
    deletionError: 'Erreur lors de la suppression du prompt',
    deleteConfirmTitle: 'Supprimer le prompt',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce prompt ?',
    deleteWarning: 'Cette action ne peut pas être annulée.',
  },
  promptEditor: {
    title: 'Éditeur de prompt',
    subtitle: 'Créez et modifiez vos prompts',
    save: 'Enregistrer le prompt',
    saved: 'Prompt enregistré',
    saveError: "Erreur lors de l'enregistrement du prompt",
    variables: 'Variables',
    addVariable: 'Ajouter une variable',
    variableName: 'Nom de la variable',
    variablePlaceholder: 'Entrez le nom de la variable',
    variableExample: 'Exemple : nom, contexte, date',
    removeVariable: 'Supprimer la variable',
  },
  promptPresets: {
    title: 'Préréglages de prompt',
    subtitle: 'Choisissez parmi des paramètres de prompt prédéfinis',
    systemPrompts: 'Prompts système',
    userPrompts: 'Prompts utilisateur',
    assistantPrompts: 'Prompts assistant',
    tone: 'Ton',
    tones: {
      professional: 'Professionnel',
      casual: 'Décontracté',
      friendly: 'Amical',
      formal: 'Formel',
    },
    style: 'Style',
    styles: {
      concise: 'Concise',
      detailed: 'Détaillé',
      persuasive: 'Persuasif',
      informative: 'Informatif',
    },
  },
  knowledge: {
    title: 'Sources de connaissance',
    subtitle: 'Gérez les sources de données pour vos assistants',
    addSource: 'Ajouter une source',
    searchSources: 'Rechercher des sources',
    sourceType: 'Type de source',
    sourceTypes: {
      document: 'Document',
      url: 'URL',
      database: 'Base de données',
    },
    status: 'Statut',
    statuses: {
      processing: 'En cours de traitement',
      ready: 'Prêt',
      failed: 'Échec',
    },
    lastUpdated: 'Dernière mise à jour',
    actions: 'Actions',
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette source ?',
    deleteWarning: 'Cette action ne peut pas être annulée.',
  },
  knowledgeForm: {
    title: 'Ajouter une source de connaissance',
    sourceType: 'Type de source',
    name: 'Nom',
    description: 'Description',
    url: 'URL',
    file: 'Fichier',
    status: 'Statut',
    submit: 'Soumettre',
    submitting: 'Soumission...',
    submitted: 'Soumis',
    submitError: 'Erreur lors de la soumission de la source',
  },
  knowledgeStatus: {
    processing: 'En cours de traitement',
    ready: 'Prêt',
    failed: 'Échec',
  },
  behavior: {
    title: 'Comportement',
    systemPrompt: 'Prompt système',
    instructions: 'Instructions',
    temperature: 'Température',
    maxTokens: 'Nombre max de tokens',
    topP: 'Top P',
    frequencyPenalty: 'Pénalité de fréquence',
    presencePenalty: 'Pénalité de présence',
    save: 'Enregistrer',
    saved: 'Enregistré',
    saveError: "Erreur lors de l'enregistrement",
  },
  placeholders: {
    search: 'Rechercher...',
    enterText: 'Saisissez du texte...',
    enterName: 'Saisissez un nom...',
    enterDescription: 'Saisissez une description...',
  },
  roles: {
    owner: 'Propriétaire',
    admin: 'Admin',
    editor: 'Éditeur',
    viewer: 'Lecteur',
  },
  pagination: {
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    of: 'de',
  },
  emptyStates: {
    noData: 'Aucune donnée disponible',
    noResults: 'Aucun résultat',
    noAccess: 'Aucun accès',
  },
  filters: {
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    clear: 'Effacer',
    sort: 'Trier',
    filter: 'Filtrer',
  },
  breadcrumbs: {
    home: 'Accueil',
    back: 'Retour',
  },
  tags: {
    addTag: 'Ajouter une étiquette',
    add: 'Ajouter',
    remove: 'Supprimer',
    required: 'Au moins une étiquette est requise',
    tagsHelp: 'Les étiquettes aident à organiser et catégoriser votre assistant',
    exampleQuestions: 'Questions exemples',
    exampleQuestionsHelp:
      'Ajoutez des questions exemples sur lesquelles les utilisateurs peuvent cliquer pour démarrer une conversation',
  },
  editAgent: {
    title: "Modifier l'assistant",
    subtitle: 'Modifiez les paramètres et le comportement de votre assistant IA',
    updateAgent: "Mettre à jour l'assistant",
    deleteAgent: "Supprimer l'assistant",
    updating: 'Mise à jour...',
    deleting: 'Suppression...',
    agentUpdated: 'Assistant mis à jour',
    updatedSuccessfully: 'a été mis à jour avec succès',
    updateError: 'Erreur de mise à jour',
    updateErrorDescription: "Une erreur s'est produite lors de la mise à jour de l'assistant. Veuillez réessayer.",
    agentDeleted: 'Assistant supprimé',
    deletedSuccessfully: 'a été supprimé avec succès',
    deleteError: 'Erreur de suppression',
    deleteErrorDescription: "Une erreur s'est produite lors de la suppression de l'assistant. Veuillez réessayer.",
    deleteConfirmTitle: "Supprimer l'assistant",
    deleteConfirmMessage:
      'Êtes-vous sûr de vouloir supprimer cet assistant ? Cette action ne peut pas être annulée.',
    confirmDelete: 'Oui, supprimer',
    loadingAgent: "Chargement des détails de l'assistant...",
    failedToLoad: "Échec du chargement des détails de l'assistant",
  },
  jobCategory: {
    addNew: 'Ajouter une catégorie',
    name: 'Nom',
    nameRequired: 'Le nom de catégorie est requis',
    enterName: 'Entrez le nom de la catégorie...',
    create: 'Créer',
    edit: 'Modifier',
    update: 'Mettre à jour',
    delete: 'Supprimer',
    created: 'Catégorie créée',
    createdSuccessfully: 'a été créée avec succès',
    updated: 'Catégorie mise à jour',
    updatedSuccessfully: 'a été mise à jour avec succès',
    deleted: 'Catégorie supprimée',
    deletedSuccessfully: 'a été supprimée avec succès',
    creationError: 'Erreur de création',
    creationErrorDescription: "Une erreur s'est produite lors de la création de la catégorie",
    updateError: 'Erreur de mise à jour',
    updateErrorDescription: "Une erreur s'est produite lors de la mise à jour de la catégorie",
    deletionError: 'Erreur de suppression',
    deletionErrorDescription: "Une erreur s'est produite lors de la suppression de la catégorie",
    deleteError: 'Erreur de suppression',
    deleteErrorDescription: "Une erreur s'est produite lors de la suppression de la catégorie",
    deleteConfirmTitle: 'Supprimer la catégorie',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer "{{name}}" ?',
    deleteWarning: 'Cette action ne peut pas être annulée et peut affecter les assistants existants.',
    warning: 'Avertissement',
    agentsWillLoseCategory: 'les assistants perdront leur attribution de catégorie',
  },
  languageNames: {
    en: 'Anglais',
    nl: 'Néerlandais',
    de: 'Allemand',
    fr: 'Français',
    it: 'Italien',
    pl: 'Polonais',
    hu: 'Hongrois',
    id: 'Indonésien',
  },
  knowledgeSourceSelector: {
    title: 'Sources de connaissances',
    tooltip: 'Choisissez les sources de connaissances à rechercher',
    all: 'Toutes',
  },
  countries: {
    nl: 'Pays-Bas',
    us: 'Amériques',
    hu: 'Hongrie',
    id: 'Indonésie',
  },
  iconSelector: {
    chooseIcon: 'Choisir une icône',
  },
  models: {
    optionUnavailable: '{{model}} — temporairement indisponible',
    modelRateLimited: '{{model}} est temporairement limité. Les demandes sont dirigées vers le modèle disponible suivant.',
    modelUnavailable: '{{model}} est actuellement indisponible. Les demandes sont dirigées vers un autre modèle.',
    fallbackToast: 'Passé à {{fallbackModel}} — {{originalModel}} temporairement indisponible.',
    recommended: 'Recommandé',
    verifySources: "Cette réponse provient d'un modèle moins fiable sur les questions RH. Vérifiez-la auprès de la source avant d'agir.",
    introHeading: 'Réglages des modèles',
    introBody: "Sur cette page, tu règles le comportement de chaque modèle. Quel modèle est utilisé pour une conversation ne se choisit pas ici, tu le sélectionnes dans le chat lui-même, à côté du champ de saisie où tu tapes ta question.",
    noConfigurableParameters: 'Aucun réglage pour ce modèle',
  },
}

const clientDefaults = {
  fallbackAgentDescription: "Assistant IA pour les connaissances entreprise d'AHV International.",
}

export default { ...frTranslation, ...clientDefaults }
